/* eslint-disable react/destructuring-assignment */

import { Field, FieldProps, FieldRenderProps } from 'react-final-form'
import SelectField, { Option, PossibleValue } from 'components/ui/SelectField'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const EMPTY_FIELD_PROPS: Partial<FieldProps<any, any>> = {}

type RadioGroupProps<T extends PossibleValue> = {
  description?: string
  label: string
  options: Option<T>[]
  newDesign?: boolean
}

export type Props<T extends PossibleValue> = RadioGroupProps<T> & {
  name: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  fieldProps?: Partial<FieldProps<any, any>>
}

function InnerFormSelectField<T extends PossibleValue>({
  description,
  label,
  options,
  input,
  name,
  newDesign,
  meta: { touched, error: syncError, submitError }
}: FieldRenderProps<T, HTMLInputElement> & RadioGroupProps<T>) {
  const error = syncError || submitError
  const showError = (touched || submitError) && !!error
  return (
    <SelectField<T>
      description={description}
      error={showError ? error : null}
      label={label}
      name={name}
      newDesign={newDesign}
      onChange={(value) => {
        input.onChange(value)
        input.onBlur()
      }}
      options={options}
      value={input.value}
    />
  )
}

export default function FormSelectField<T extends PossibleValue = string>({
  name,
  fieldProps = EMPTY_FIELD_PROPS,
  ...innerProps
}: Props<T>) {
  return (
    <Field<T, FieldRenderProps<T, HTMLInputElement>, HTMLInputElement>
      name={name}
      render={(props) => (
        <InnerFormSelectField<T> {...props} {...innerProps} name={name} />
      )}
      {...fieldProps}
    />
  )
}
